// Taken directly from tamagui but handles the color prop for web due to the
// theme not being applied correctly
import type * as React from "react";
import { ActivityIndicator } from "react-native";
import { isWeb } from "tamagui";
import type { ColorTokens, TamaguiElement, ThemeTokens } from "@tamagui/core";
import { useTheme, variableToString } from "@tamagui/core";
import { YStack, type YStackProps } from "./Stacks";
export type SpinnerProps = Omit<YStackProps, "children"> & {
  size?: "small" | "large" | number;
  color?: (ColorTokens | ThemeTokens | (string & {})) | null;
};
const isHexCode = (str: string) => /^#([0-9A-F]{3}){1,2}$/i.test(str);
export const Spinner: React.ForwardRefExoticComponent<SpinnerProps & React.RefAttributes<TamaguiElement>> = YStack.styleable((props: SpinnerProps, ref: React.Ref<TamaguiElement>) => {
  const {
    size,
    color: colorProp,
    ...stackProps
  } = props;
  const theme = useTheme();
  let color = colorProp as string;
  if (color && color[0] === "$") {
    color = variableToString(theme[color]);
  } else if (isWeb && !isHexCode(color)) {
    color = "gray";
  }
  return <YStack ref={ref} {...stackProps}>
      <ActivityIndicator size={size} color={color} />
    </YStack>;
});